<template>
  <sidenav
    :custom_class="this.$store.state.mcolor"
    class="fixed-start"
    v-if="this.$store.state.showSidenav"
  />
  <main class="main-content position-relative max-height-vh-100 h-100" :class="[navClasses]">
    <!-- nav -->
    <NavCabecera
      v-if="this.$store.state.showNavbar"
    />
    <router-view />
  </main>
</template>
<script>
import Sidenav from "./examples/Sidenav";
import NavCabecera from "@/views/components/NavCabecera.vue";
//import { mapMutations } from "vuex";
import '@fortawesome/fontawesome-free/css/all.css';

export default {
  name: "App",
  components: {
    Sidenav,
    NavCabecera,
  },
  methods: {
    //...mapMutations(["toggleConfigurator", "navbarMinimize"]),
  },
  computed: {
    navClasses() {
      return {
      //  "position-sticky blur shadow-blur mt-4 left-auto top-1 z-index-sticky": this.$store.state.isNavFixed,
      //  "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state.isAbsolute,
      //  "px-0 mx-4 mt-4": !this.$store.state.isAbsolute,
        "hayNavbar": this.$store.state.showNavbar,
      };
    },
  },
  beforeMount() {
  },
};
</script>
